/**
 * Binom offers list hook — backs BinomOfferPicker's "Offer" tab.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';
import { binomKeys } from './useBinom';

export interface BinomOffer {
  id: string;
  name: string;
  url?: string;
  countryCode?: string;
  affiliateNetworkId?: string;
}

const offersKey = (search: string) =>
  [...binomKeys.all, 'offers', search] as const;

export function useBinomOffers(search = '') {
  return useQuery({
    queryKey: offersKey(search),
    queryFn: async () => {
      const qs = search ? `?search=${encodeURIComponent(search)}` : '';
      const r = await api.get<{ data: BinomOffer[] | unknown }>(
        `/binom/offers${qs}`,
      );
      const d = r.data?.data;
      if (Array.isArray(d)) return d;
      const items = (d as { items?: BinomOffer[] } | undefined)?.items;
      return Array.isArray(items) ? items : [];
    },
    staleTime: 60_000,
  });
}
